export default __webpack_public_path__ + "static/media/Social_Follow_Component.06631d3d.PNG";